import axios from 'axios';
import { createApiUrl } from '../config/api';

const API_URL = createApiUrl('/api/products');

export const getProducts = async (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  ).toString();
  const path = query ? `/api/products?${query}` : "/api/products";
  const response = await axios.get(createApiUrl(path));
  return response.data;
};

export const createProduct = async (product) => {
  const response = await axios.post(API_URL, product);
  return response.data;
};

export const updateProduct = async (id, product) => {
  const response = await axios.put(`${API_URL}/${id}`, product);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};

export const getProductStockSummary = async () => {
  const response = await axios.get(createApiUrl('/api/products/stock-summary'));
  return response.data;
};
